enum AppEnv {
  Production = 'production',
  Staging = 'staging',
  Development = 'development'
}

const APP_ENV = getAppEnv()
console.log(`APP_ENV: ${APP_ENV}`)

// You can pass in the Developer url as a query param.  This is useful for
// allowing developers to connect to a deployed AMP but have it talk to their
// local Developer instance.
const DEVELOPER_URL = new URLSearchParams(window.location.search).get('dev_url')
console.log(`DEVELOPER_URL: ${DEVELOPER_URL}`)

function getAppEnv(): AppEnv {
  switch (process.env.REACT_APP_ENV) {
    case 'prd':
      return AppEnv.Production
    case 'stg':
      return AppEnv.Staging
    case 'dev':
      return AppEnv.Development
    default:
      // Default to production to be safer for auth, errors, etc.
      // Similar to 'NODE_ENV=production'
      return AppEnv.Production
  }
}

export function isDevEnv(): boolean {
  return APP_ENV === AppEnv.Development
}

export function getAuthBaseUrl(): string {
  // If we've got the developer url as a query param then use that,
  // otherwise use the default values
  if (DEVELOPER_URL) {
    return DEVELOPER_URL
  }

  switch (APP_ENV) {
    case AppEnv.Production:
      return 'https://app.energytoolbase.com'
    case AppEnv.Staging:
      return 'https://developer-stg.energytoolbase.com'
    case AppEnv.Development:
      return 'https://localhost:44300'
  }
}

export function getLogLevel(): string {
  switch (APP_ENV) {
    case AppEnv.Production:
      return 'info'
    case AppEnv.Staging:
      return 'debug'
    case AppEnv.Development:
      return 'debug'
  }
}

export function getDeveloperBaseUrl(): string {
  // If we've got the developer url as a query param then use that,
  // otherwise use the default values
  if (DEVELOPER_URL) {
    return DEVELOPER_URL
  }

  switch (APP_ENV) {
    case AppEnv.Production:
      return 'https://app.energytoolbase.com'
    case AppEnv.Staging:
      return 'https://developer-stg.energytoolbase.com'
    case AppEnv.Development: {
      return 'https://localhost:44300'
    }
  }
}

export function getDeveloperUrl(): string {
  const baseUrl = getDeveloperBaseUrl()
  return `${baseUrl}/esco`
}

export function getDeveloperApiUrl(): string {
  const baseUrl = getDeveloperBaseUrl()
  return `${baseUrl}/api`
}

export function getServicesUrl(): string {
  const baseUrl = getDeveloperBaseUrl()
  return `${baseUrl}/services`
}

export function getMonitorUrl(): string {
  switch (APP_ENV) {
    case AppEnv.Production:
      return 'https://monitor.energytoolbase.com'
    case AppEnv.Staging:
      return 'https://monitor-stg.energytoolbase.com'
    case AppEnv.Development: {
      return 'https://localhost:3000'
    }
  }
}

export function getGoogleMapsAPIKey(): string {
  // Usage of the Google Maps API key is restricted by URL.
  // The dev key can only be used from localhost:3000 and the prd key can only be used from *.energytoolbase.com.
  // We need to check hostname since staging can be either.
  return (
    (window.location.hostname === 'localhost'
      ? process.env.REACT_APP_GOOGLE_MAPS_API_KEY_DEV
      : process.env.REACT_APP_GOOGLE_MAPS_API_KEY_PRD) ?? ''
  )
}

export function getStripeClientKey(): string {
  switch (APP_ENV) {
    case AppEnv.Production:
      return process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY_LIVE ?? ''
    default:
      return process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY_TEST ?? ''
  }
}

export function getProfilePictureUrl(
  guid: string | undefined,
  variant: 'small' | 'large'
): string | undefined {
  const storageRoot = process.env.PROFILE_STORAGE?.length
    ? process.env.PROFILE_STORAGE
    : 'https://globaldocumentstorage.blob.core.windows.net/profile-pictures'
  return guid ? `${storageRoot}/${variant}/${guid}.jpg` : undefined
}
